import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "campaign-classic-event-reference"
    }}>{`Campaign Classic event reference`}</h1>
    <h2 {...{
      "id": "events-handled"
    }}>{`Events handled`}</h2>
    <p>{`The following events are handled by the Adobe Campaign Classic extension:`}</p>
    <h3 {...{
      "id": "campaign-request-content"
    }}>{`Campaign request content`}</h3>
    <p>{`This event is a request to make a registration or a track (receive or click) call and is generated by the API when the following conditions are met:`}</p>
    <ul>
      <li parentName="ul">{`When a registration request needs to be sent (`}<inlineCode parentName="li">{`registerDevice`}</inlineCode>{`).`}</li>
      <li parentName="ul">{`When a track receive request needs to be sent (`}<inlineCode parentName="li">{`trackNotificationReceive`}</inlineCode>{`).`}</li>
      <li parentName="ul">{`When a track click request needs to be sent (`}<inlineCode parentName="li">{`trackNotificationClick`}</inlineCode>{`).`}</li>
    </ul>
    <h4 {...{
      "id": "registerdevice"
    }}>{`registerDevice`}</h4>
    <p>{`The following key-value pairs are used in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Required`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`additionalParameters`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`VariantMap`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An optional map that contains additional key/value pairs to be sent with the registration event.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`deviceToken`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The device token retrieved from Firebase Cloud Messaging.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`registerDevice`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This value is populated when `}<inlineCode parentName="td">{`registerDevice`}</inlineCode>{` API is called.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`deviceInfo`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`StringMap`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A map that contains the device information, including the device name, brand, manufacturer, and UUID.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`userKey`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A string that identifies the user, such as an email address.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The `}<inlineCode parentName="p">{`registerDevice`}</inlineCode>{` API parameters are also sent in the event, as described below. The `}<inlineCode parentName="p">{`deviceinfo`}</inlineCode>{` map is internally populated.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "additionalParameters": {
        "firstName": "John",
        "lastName": "Doe",
        "zipCode": 94403,
        "testId": "11000.1110002321321",
        "region": "US",
        "userId": "123999333",
        "age": 28
    },
    "deviceToken": "d6x4Bu6pxDg:APA91bG9jZb6oQ3-sExUZRbaYP_LjA6POO0NXMaUaxcBQj9GF5ZBGlFo76raIabLziMMt2mLhLafBW9kYqiZ3Nemwjox3Hg6muTPyLeMOuGj24mCitVt73_KML184meqLYXCqhvg53MI",
    "registerDevice": true,
    "deviceInfo": {
        "deviceName": "generic_x86",
        "deviceBrand": "Android",
        "deviceManufacturer": "unknown",
        "deviceUuid": "00000000-3398-7b70-0000-000033987b70"
    },
    "userKey": "john@example.com"
}
`}</code></pre>
    <h4 {...{
      "id": "tracknotificationreceive"
    }}>{`trackNotificationReceive`}</h4>
    <p>{`The following key-value pairs are used in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Key`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Value Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`trackReceive`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A boolean value populated when the  `}<inlineCode parentName="td">{`trackNotificationReceive`}</inlineCode>{` API is called.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`trackInfo`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`StringMap`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A map containing the tracking identifiers received in the message payload.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The `}<inlineCode parentName="p">{`trackNotificationReceive`}</inlineCode>{` parameters are also sent in the event, as described below:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "trackReceive": true,
    "trackInfo": {
        "_mId": "12345",
        "_dId": "f0190"
    }
}
`}</code></pre>
    <h4 {...{
      "id": "tracknotificationclick"
    }}>{`trackNotificationClick`}</h4>
    <p>{`The following key-value pairs are used in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Key`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Value Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`trackClick`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A boolean value populated when the `}<inlineCode parentName="td">{`trackNotificationClick`}</inlineCode>{` API is called.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`trackInfo`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`StringMap`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A map containing tracking identifiers that were received in the message payload.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The `}<inlineCode parentName="p">{`trackNotificationClick`}</inlineCode>{` parameters are also sent in the event, as described below:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "trackClick": true,
    "trackInfo": {
        "_mId": "12345",
        "_dId": "f0190"
    }
}
`}</code></pre>
    <h3 {...{
      "id": "configuration-response-content"
    }}>{`Configuration response content`}</h3>
    <p>{`The data property in this event is used by each extension to modify its settings. Each extension is responsible for reading out the part of the data property for which it is concerned.`}</p>
    <h4 {...{
      "id": "data-payload-definition"
    }}>{`Data payload definition`}</h4>
    <p>{`The following key/value pair is used by the Adobe Campaign Classic extension from the configuration event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Optional`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`global.privacy`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This contains the mobile privacy status settings.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "events-dispatched"
    }}>{`Events dispatched`}</h2>
    <p>{`The following events are dispatched by the Campaign Classic extension:`}</p>
    <h3 {...{
      "id": "campaign-response-content"
    }}>{`Campaign response content`}</h3>
    <p>{`This event is a response from the Campaign Classic extension to notify the result of the registration request that is sent to the Campaign Classic marketing server.`}</p>
    <p>{`This event is dispatched in a response to the `}<inlineCode parentName="p">{`registerDevice`}</inlineCode>{` API and contains a `}<inlineCode parentName="p">{`registrationstatus`}</inlineCode>{` key of type `}<em parentName="p">{`boolean,`}</em>{` which signals the success or failure of the registration request.`}</p>
    <h4 {...{
      "id": "event-details"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Source`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventType.campaign`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventSource.responseContent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-definition-1"
    }}>{`Data payload definition`}</h4>
    <p>{`The following key-value pair is used in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Optional`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`registrationstatus`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A boolean containing the registration request success status`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "event-data-example"
    }}>{`Event data example`}</h4>
    <p><strong parentName="p">{`Registration status`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "registrationstatus": true
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      